import gql from 'graphql-tag';

export default gql`
  fragment clientDownloadMailCampaignFragment on ClientDownloadMailCampaign {
    id
    file
    filename
    count
    createdAt
  }
`;
